import React from "react";
import { useHistory } from "react-router";
import { BlockMachine } from "../../Context/Context";

import "./search-hash.style.scss";
export default function SearchHash() {
  const history = useHistory();

  const [searchTerm, setSearchTerm] = React.useState("");
  const context = React.useContext(BlockMachine);
  return (
    <div className="search-hash-main">
      <div className="search-input-wrapper">
        <input
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search By Address/Txn Hash/Block/Token"
        />
      </div>
      <button>
        <img src="https://img.icons8.com/android/50/ffffff/search.png" />
      </button>
      <div className={`search-dropdown ${!searchTerm?"hide-it":""}`}>
        {!context.allBlocks
          ? ""
          : context.allBlocks
              .filter((x) => {
                return (
                  searchTerm &&
                  x.hash.toLowerCase().startsWith(searchTerm.toLowerCase())
                );
              })
              .slice(0, 5)
              .map((obj) => (
                <div
                  onClick={() => {
                    history.push(`/home/transaction/${obj.hash}`);
                    setSearchTerm("");
                  }}
                >
                  <p>
                    <span>Hash:</span>
                    {obj.hash}
                  </p>
                </div>
              ))}
      </div>
    </div>
  );
}
